export const handleSetIsMobile = (isMobile) => ({
    type: 'IS_MOBILE', isMobile
});